import React from 'react';
import SectionTitle from '../sectionTitle/SectionTitle';



const AboutFive = () => {
    return (
        <div className="slider-area slider-style-1 height-650 bg-white">
        <div className="container">
        <div className="row">
                <div className="col-lg-12">
                  <SectionTitle
                    textAlign="text-center"
                    radiusRounded=""
                    subtitle="Método 3"
                  />
                </div>
              </div>
          <div className="row align-items-center">
            <div className="col-lg-7 col-xl-6 order-2 order-lg-1 mt_md--40 mt_sm--40">

              <div className="inner text-start">
                <h1 className="title theme-gradient display-one">
                  NO mystery shooper
                </h1>
                <span className="subtitle">¿Que hacemos?</span>
                <p className="p2">
                  Un “NO MYSTERY SHOOPER” trabaja como un mystery
                  tradicional pero sin estar de incógnito. Es un auditor
                  designado por la empresa , que promueve la honestidad y la
                  transparencia en la evaluación que realiza, permitiendo al
                  personal comprender y alcanzar los estándares de la
                  empresa de una manera más efectiva.
                </p>

                <p className="p2">
                  Asi es como auditamos tu restaurante fijando los
                  parámetros a mejorar, dando feedback al equipo y
                  estableciendo metas claras.
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-xl-6 order-1 order-lg-2">
              <div className="thumbnail">
                <img
                  src="./dare/mistery2.png"
                  alt="consultoria gastronomica"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}
export default AboutFive;